module.exports = __webpack_public_path__ + "img/video-thumb-8-nl.83e57e71.png";